// extracted by mini-css-extract-plugin
export var acitonButtons = "_gh-0";
export var additionalIcon = "_gh-f";
export var block = "_gh-1";
export var blockContent = "_gh-7";
export var blockDescription = "_gh-8";
export var blockIcon = "_gh-9";
export var blockTitle = "_gh-6";
export var border = "_gh-a";
export var center = "_gh-l";
export var edge = "_gh-b";
export var edgeLabel = "_gh-c";
export var edgePath = "_gh-d";
export var error = "_gh-e";
export var flowchart = "_gh-g";
export var flowchartContent = "_gh-h";
export var highlighted = "_gh-3";
export var hover = "_gh-4";
export var icon = "_gh-i";
export var left = "_gh-m";
export var navButton = "_gh-j";
export var navButtons = "_gh-k";
export var right = "_gh-n";
export var selected = "_gh-2";
export var small = "_gh-5";